import Vue from "vue";
import Vuex from "vuex";

// system
import navCollection from "./modules/navCollection.js";
import auth from "./modules/auth.js";
import auth_oc from "./modules/auth_oc.js";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    navCollection,
    auth,
    auth_oc
  }
  // strict: true
});
